module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_oval_chestnut.d4071f44.png";